<template>
    <div class="btn_config_config chartConfig_viewDP">
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">选择字体</span>
            <el-select v-model="config.font.fontFamily" placeholder="请选择字体"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in familyList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">字体大小</span>
            <el-input v-model="config.font.fontSize" @change="getRender" type="number"></el-input>
            <div class="unit">px</div>
        </div>
        <div class="chartDivConfig colViewConfig ">
            <span class="span_til">字体颜色</span>
            <el-color-picker v-model="config.font.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">字体加粗</span>
            <el-select v-model="config.font.fontWeight" placeholder="请选择粗字号"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in weightList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">对齐方式</span>
            <el-select v-model="config.font.align" placeholder="请选择对齐方式"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in alignList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig textViewConfig ">
            <span class="span_til">编辑内容</span>
            <el-input
                    class="text_input"
                    type="textarea"
                    autosize
                    size="mini"
                    placeholder="再此修改内容！"
                    v-model="config.font.centent"
                    @change="getRender">
            </el-input>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/24 8:04 下午
     */
    export default {
        name: 'btn_config_config',
        components: {},
        data() {
            return {
                familyList:[{name:'黑体',value:'SimHei'},{name:'宋体',value:'SimSun'},{name:'楷体',value:'KaiTi'},{name:'仿宋',value:'FangSong'},{name:'华文中宋',value:'STZhongsong'},{name:'华文行楷',value:'STXingkai'}],
                weightList:[{name:'细',value:'lighter'},{name:'粗',value:'bold'},{name:'更粗',value:'bolder'}],
                alignList:[{name:'靠左对齐',value:'left'},{name:'居中对齐',value:'center'},{name:'靠右对齐',value:'right'}],
            }
        },
        props: {
            type: {
                type: String,
                default: ''
            },
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart.setting.params;
                }
            },
        },
        methods: {
            getRender() {
                if (this.type === 'view') {
                    this.$store.dispatch('viewDPRender');
                } else if (this.type === 'screen') {
                    this.$store.dispatch('screenRender');
                }
            },
        },

        mounted() {
        },
        destroyed() {

        }

    }
</script>

<style lang="less">
    .btn_config_config {

    }
</style>
